export const PIN = {
  DRIVER: "https://resource.supergasbras.app/image/pindriver.png",
  ORDER: "https://resource.supergasbras.app/image/pinorder.png",
  DEALER: "https://resource.supergasbras.app/image/pindealer.png",
};
